module.exports = {"modalTitle":"Eine oder mehrere Region(en) auswählen","title":"Abos","intro":"Für welche Region(en) sollen Abos angezeigt werden?","selectRegions":"Region(en) wählen","changeRegionSelection":"Region(en) ändern","buttonText":"Abos anzeigen"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/de/region-select.json
// module id = WGud
// module chunks = 1